export default "__VITE_ASSET__7b8367fb__"